import { render, staticRenderFns } from "./ReconciliationRemarkDialog.vue?vue&type=template&id=2c04f854"
import script from "./ReconciliationRemarkDialog.vue?vue&type=script&lang=js"
export * from "./ReconciliationRemarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c04f854')) {
      api.createRecord('2c04f854', component.options)
    } else {
      api.reload('2c04f854', component.options)
    }
    module.hot.accept("./ReconciliationRemarkDialog.vue?vue&type=template&id=2c04f854", function () {
      api.rerender('2c04f854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/statement/components/ReconciliationRemarkDialog.vue"
export default component.exports